<template>
  <div class="container">
    <!-- <MainTitle title="Regulación"/> -->
    <MainTitle
      title="Regulación"
      description="Observatorio normativo sobre reducción escalonada y construcción de alternativas"
    />
    <div class="contenedor-pdf-box">
      <div class="pdf-box">
        <DocumentLink
          url="https://dof.gob.mx/nota_detalle.php?codigo=5679405&fecha=13/02/2023"
          name="Decreto vigente 2023"
          cover="descargables/regulacion/dof-2023.png"
        />
      </div>
      <div class="pdf-box">
        <DocumentLink
          url="https://www.dof.gob.mx/nota_detalle.php?codigo=5609365&fecha=31/12/2020"
          name="Decreto diciembre 2020"
          cover="descargables/regulacion/dof.jpg"
        />
      </div>
    </div>

    <div class="columns is-multiline m-t-3">
      <div class="column doc-box">
        <h2 class="subtitulo">
          Convenios Internacionales<span class="a11y-solo-lectura">.</span>
        </h2>
        <DocumentLink
          url="https://www.un.org/spanish/esa/sustdev/documents/declaracionrio.htm"
          name="Declaración de Río sobre el Medio Ambiente y el Desarrollo"
        />
        <DocumentLink
          url="https://aplicaciones.sre.gob.mx/tratados/ARCHIVOS/DIVERSIDAD_BIOLOGICA.pdf"
          name="Convenio sobre la Diversidad Biológica"
        />
        <DocumentLink
          url="https://aplicaciones.sre.gob.mx/tratados/ARCHIVOS/PROT_CARTAGENA.pdf"
          name="Protocolo de Cartagena sobre Seguridad de la Biotecnología"
        />
        <DocumentLink
          url="https://www.ohchr.org/sp/professionalinterest/pages/cescr.aspx"
          name="Pacto Internacional de Derechos Económicos, Sociales y Culturales"
        />
        <DocumentLink
          url="https://aplicaciones.sre.gob.mx/tratados/ARCHIVOS/CONV.%20AMERICANA%20SOBRE%20DERECHOS%20HUMANOS.pdf"
          name="Convención Americana sobre Derechos Humanos"
        />
      </div>
      <div class="column doc-box">
        <h2 class="subtitulo">
          Leyes Federales<span class="a11y-solo-lectura">.</span>
        </h2>
        <DocumentLink
          url="http://www.diputados.gob.mx/LeyesBiblio/pdf/LFFPMN_130420.pdf"
          name="Ley Federal para el Fomento y Protección del Maíz Nativo"
        />
        <DocumentLink
          url="http://www.diputados.gob.mx/LeyesBiblio/pdf/LBOGM_061120.pdf"
          name="Ley de Bioseguridad de los Organismos Genéticamente Modificados"
        />
        <DocumentLink
          url="http://www.diputados.gob.mx/LeyesBiblio/pdf/LGS.pdf"
          name="Ley General de Salud"
        />
        <DocumentLink
          url="http://www.diputados.gob.mx/LeyesBiblio/pdf/148_180121.pdf"
          name="Ley General de Equilibrio Ecológico y Protección al Ambiente"
        />
        <DocumentLink
          url="http://www.diputados.gob.mx/LeyesBiblio/pdf/117_261217.pdf"
          name="Ley General de Sanidad Vegetal"
        />
        <DocumentLink
          url="https://www.gob.mx/cms/uploads/attachment/file/317971/Ley_de_productos_org_nicos.pdf"
          name="Ley de Productos Orgánicos"
        />
      </div>
      <div class="column doc-box">
        <h2 class="subtitulo">
          Normas Oficiales Mexicanas<span class="a11y-solo-lectura">.</span>
        </h2>
        <DocumentLink
          url="http://dof.gob.mx/nota_detalle.php?codigo=5499806&fecha=04/10/2017"
          name="NOM-082-SAG-FITO/SSA1-2017"
        />
        <DocumentLink
          url="http://dof.gob.mx/nota_detalle.php?codigo=5139018&fecha=13/04/2010"
          name="NOM-232-SSA1-2009"
        />
        <DocumentLink
          url="http://dof.gob.mx/nota_detalle.php?codigo=5242199&fecha=04/04/2012"
          name="Modificación de los numerales 4.1.8, 6.2.7, 6.3.7, 8.2.7"
        />
        <DocumentLink
          url="http://dof.gob.mx/nota_detalle.php?codigo=5546741&fecha=18/12/2018"
          name="MODIFICACIÓN de los numerales 5, 8, 9"
        />
        <DocumentLink
          url="http://dof.gob.mx/nota_detalle.php?codigo=5286029&fecha=29/01/2013"
          name="NOM-256-SSA1-2012"
        />
        <DocumentLink
          url="http://dof.gob.mx/nota_detalle.php?codigo=5276453&fecha=02/11/2012"
          name="ACUERDO por el que se determinan Centros de Origen y Centros de Diversidad Genética del Maíz"
        />
      </div>
      <div class="column doc-box">
        <h2 class="subtitulo">
          Programas Gubernamentales Federales<span class="a11y-solo-lectura"
            >.</span
          >
        </h2>
        <DocumentLink
          url="https://www.dof.gob.mx/nota_detalle.php?codigo=5565599&fecha=12/07/2019"
          name="Plan Nacional de Desarrollo 2019-2024"
        />
        <DocumentLink
          url="https://www.dof.gob.mx/nota_detalle.php?codigo=5596232&fecha=07/07/2020"
          name="Programa Sectorial de Medio Ambiente y Recursos Naturales 2020-2024"
        />
        <DocumentLink
          url="https://dof.gob.mx/nota_detalle.php?codigo=5595549&fecha=25/06/2020"
          name="Programa Sectorial de Agricultura y Desarrollo Rural 2020-2024"
        />
        <DocumentLink
          url="http://dof.gob.mx/nota_detalle.php?codigo=5595309&fecha=23/06/2020"
          name="Programa Institucional del Consejo Nacional de Ciencia y Tecnología 2020-2024"
        />
      </div>
      <div class="column doc-box">
        <h2 class="subtitulo">
          Otras referencias relevantes en materia de bioseguridad<span
            class="a11y-solo-lectura"
            >.</span
          >
        </h2>
        <DocumentLink
          url="https://www.conacyt.gob.mx/cibiogem/index.php/normatividad/normatividad-vigente-en-materia-de-bioseguridad"
          name="Marco jurídico en materia de bioseguridad"
        />
        <DocumentLink
          url="https://www.conacyt.gob.mx/cibiogem/index.php/normatividad/estandares-dh-bioseguridad/list-dh-docs"
          name="Estándares internacionales de derechos humanos aplicables a la Bioseguridad"
        />
        <DocumentLink
          url="https://www.conacyt.gob.mx/cibiogem/index.php/normatividad/eidh-docs/pueblos-plaguicidas-eidh"
          name="Estándares internacionales de derechos humanos para la construcción de una política pública en materia de pueblos indígenas y afromexicanos expuestos a plaguicidas"
        />
        <DocumentLink
          url="http://transparencia.cofepris.gob.mx/index.php/es/marco-juridico"
          name="Marco jurídico de la COFEPRIS"
        />
        <DocumentLink
          url="https://www.gob.mx/senasica/acciones-y-programas/normateca-78776"
          name="Normateca Institucional del Senasica"
        />
        <DocumentLink
          url="https://www.gob.mx/senasica/documentos/regulacion-de-productos-organicos-en-mexico"
          name="Regulación de productos orgánicos en México"
        />
      </div>
      <div class="column doc-box">
        <h2 class="subtitulo">
          Demandas de Soberanía Alimentaria<span
            class="a11y-solo-lectura"
            >.</span
          >
        </h2>
        <DocumentLink
          url="descargables/alternativas/materiales/Anexo1_Demandas_Soberania_Alimentaria_Convocatoria_2021.pdf"
          name="Anexo 1. Demanda Convocatoria 2021 para la elaboración de protocolos de investigación e incidencia en materia de soberanía alimentaria"
        />
      </div>
    </div>
  </div>
</template>

<script>
import MainTitle from "@/components/MainTitle.vue";
import DocumentLink from "@/components/DocumentLink.vue";

export default {
  components: {
    MainTitle,
    DocumentLink,
  },
};
</script>

<style scoped lang="scss">
.contenedor-pdf-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  gap: 16px;
  @media (max-width: $breakpoint-tablet) {
    flex-wrap: wrap;
  }
  .pdf-box {
    @media (min-width: $breakpoint-tablet) {
      flex: 1 0 50%;
      max-width: 50%;
    }
  }
}

.doc-box {
  padding-top: $space;
  padding-bottom: $space;
  @media (min-width: $breakpoint-tablet) {
    flex: 1 0 calc(50% - #{$space});
    max-width: calc(50% - #{$space});
    padding-top: 0;
    padding-bottom: $space * 2;
  }
}
</style>